import React from 'react';
import { createRoot } from 'react-dom/client';

import { DemarcheFunnelLoader } from '../main-app/components/DemarchesPermis/funnel';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('react-demarche-funnel');
  const slug = node?.getAttribute('data-slug');

  if (!node || !slug) {
    return;
  }

  // Stripe's return redirect (backend-plan.md §7.2, PaymentsController#tunnel_url) carries these on
  // the query string, not as data-* attributes — the Rails controller never reads them, they exist
  // only for the frontend to pick the order back up after the round trip.
  const params = new URLSearchParams(window.location.search);
  const resumeToken = params.get('resume');
  const paymentResult = params.get('payment');

  const root = createRoot(node);
  root.render(
    <DemarcheFunnelLoader
      slug={slug}
      initialSituation={node.getAttribute('data-situation')}
      resumeToken={resumeToken}
      paymentResult={paymentResult}
    />,
  );
});
